import { useQuery } from "react-query";
import { internalApi } from "@circle-react/helpers/urlHelpers";

interface LiveStreamsConfig {
  feature_flag: string;
  value: string;
}

export const useLiveStreamsConfig = ({ enabled } = { enabled: true }) => {
  const { data: configArray, isLoading } = useQuery<LiveStreamsConfig[], Error>(
    internalApi.liveStreams.configurations(),
    {
      enabled,
    },
  );
  const config: Record<string, string> = {};
  configArray?.forEach(configObj => {
    config[configObj.feature_flag] = configObj.value;
  });

  return {
    isLoading,
    config,
  };
};
